import Vue from "vue";
import VueJsonPretty from "vue-json-pretty";

Vue.component("vue-json-pretty", VueJsonPretty);
Vue.component("related-entries", require("./RelatedEntries.vue").default);
Vue.component("index-screen", require("./IndexScreen.vue").default);
Vue.component("preview-screen", require("./PreviewScreen.vue").default);
Vue.component("alert", require("./Alert.vue").default);
